import { createFileRoute } from '@tanstack/react-router'

import { Process } from '@/pages/ControlRoom/Process/Process'

export const Route = createFileRoute('/_app/control-room/process/$processId/')({
  component: Process,
})
